// import Form from "./Form";

const FormData = [
    {
        question:"If something in your house breaks, what is the first thing you do?",
        option1:"Try to fix on my own",
        option2:"Call a preofessional",
        option3:"Call a friend",
        option4:"Try to replace it asap",
        option5:"Try to ignore it"
    },
    {
        question:"What is the ritual that helps you calm down?",
        option1:"A warm bath",
        option2:"Talking to a friend",
        option3:"Sport",
        option4:"Work",
        option5:"Sleep"
    },
    {
        question:"What is your favorite place in town?",
        option1:"Beach",
        option2:"Library",
        option3:"Club",
        option4:"Park",
        option5:"Theatre"
    },
    {
        question:"What is the thing you’d never say to another person?",
        option1:"Comment on the way the look",
        option2:"Comment on their personal lives",
        option3:"Comment on their career decisions",
        option4:"Comment on their behaviour",
        option5:"Swear at them"
    },
    {
        question:"What steps do you take to remain calm under pressure?",
        option1:"Ask for help",
        option2:"Take a break",
        option3:"Review the tasks at hand",
        option4:"Go on a vacation",
        option5:"Cry"
    }
];

export default FormData;